import React from "react";
import "./PopUpWindow.scss";

const PopUpWindow = ({ children, closePopup }) => {
  return (
    <div className="popUp-overlay">
      <div className="popUp-container">
      <button className="close" onClick={closePopup}>
          <svg width="14.851" height="14.851" viewBox="0 0 14.851 14.851">
            <path
              id="Path_2520"
              data-name="Path 2520"
              d="M156.73,156.73,144,144m12.73,0L144,156.73"
              transform="translate(-142.939 -142.939)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
          </svg>
        </button>
      <div className="popup-content">{children}</div>
      </div>
    </div>
  );
};

export default PopUpWindow;
